module.exports = __webpack_public_path__ + "static/incremental-3e9724b189a5bbe778fac942221abe3a.jpg";